<template>
    <v-tooltip left :open-delay="500">
    <template v-slot:activator="{ on }">
        <div v-on="on" v-ripple class="list-jump" @click.stop.prevent="clicked">
            <v-icon>mdi-menu-right</v-icon>
        </div>
    </template>
    <span>{{tooltip}}</span>
    </v-tooltip>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
            showingTip: false,
        }
    },

    components: {
        
    },
    
    props: {
        tooltip: String,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        clicked() {
            this.showingTip = false
            setTimeout( () => {  //give time for tooltip to close...
                this.$emit('click')
            },200)
        },
    },

    created() {

    }
}
</script>

<style scoped>
    .list-jump {
        height: 42px;
        margin-right: -12px;
        width: 16px;
        border-radius:8px;
        background-color: #f8f8f8;
        border: solid 1px #eee;
    }

    .list-jump:hover {
        /* box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important; */
        background-color: #eee;
    }

    .list-jump i {
        margin-top:8px;
        margin-left: -4px;
        color: #ccc;
    }   
</style>




// WEBPACK FOOTER //
// ListJumpButton.vue?c3535c8e